import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../lib/api';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { ArrowLeft } from 'lucide-react';

const RedefinirSenha = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [senha, setSenha] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) {
      toast.error('Link inválido. Solicite uma nova recuperação de senha.');
      return;
    }
    if (senha.length < 4) {
      toast.error('A senha deve ter pelo menos 4 caracteres.');
      return;
    }
    if (senha !== confirmar) {
      toast.error('As senhas não coincidem.');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, nova_senha: senha });
      toast.success('Senha redefinida com sucesso! Faça login com a nova senha.');
      navigate('/login');
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === 'string' ? detail : 'Não foi possível redefinir a senha.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 to-stone-100 dark:from-stone-950 dark:to-stone-900 flex items-center justify-center p-4 transition-colors duration-300">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src="/logo.png"
            alt="Logo Identidade Gente"
            className="h-16 w-auto mx-auto object-contain"
            style={{ maxWidth: '200px' }}
          />
          <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mt-4">Redefinir Senha</h1>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Crie uma nova senha</CardTitle>
            <CardDescription>Defina a nova senha de acesso ao sistema.</CardDescription>
          </CardHeader>
          <CardContent>
            {!token ? (
              <div className="text-center py-4">
                <p className="text-red-600 dark:text-red-400 font-medium">
                  Link inválido ou incompleto.
                </p>
                <Button
                  type="button"
                  variant="outline"
                  className="w-full mt-6"
                  onClick={() => navigate('/esqueci-senha')}
                  data-testid="reset-request-new-btn"
                >
                  Solicitar novo link
                </Button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4" data-testid="reset-form">
                <div>
                  <Label htmlFor="senha">Nova senha</Label>
                  <Input
                    id="senha"
                    type="password"
                    value={senha}
                    onChange={(e) => setSenha(e.target.value)}
                    placeholder="••••••••"
                    required
                    data-testid="reset-senha-input"
                  />
                </div>
                <div>
                  <Label htmlFor="confirmar">Confirmar nova senha</Label>
                  <Input
                    id="confirmar"
                    type="password"
                    value={confirmar}
                    onChange={(e) => setConfirmar(e.target.value)}
                    placeholder="••••••••"
                    required
                    data-testid="reset-confirmar-input"
                  />
                </div>
                <Button type="submit" className="w-full" disabled={loading} data-testid="reset-submit-btn">
                  {loading ? 'Salvando...' : 'Redefinir senha'}
                </Button>
                <Button
                  type="button"
                  variant="ghost"
                  className="w-full"
                  onClick={() => navigate('/login')}
                  data-testid="reset-back-btn"
                >
                  <ArrowLeft className="mr-2 h-4 w-4" />
                  Voltar para o login
                </Button>
              </form>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default RedefinirSenha;
